import { formatMessage } from '@/utils/locale';
import { FAST_ESCROW_ORDER_TYPE } from '@/stores/order/order.interface';

namespace History {
  export enum API {
    'get_user_disburse_groups' = '/fast-escrow/transaction/query_disburse_group',
    'get_user_disburse_group' = '/fast-escrow/transaction/query_disburse_group_detail',
    'get_group_orders' = '/fast-escrow/transaction/query_group_orders',
    'get_repayment_detail' = '/fast-escrow/transaction/get_repayment_detail',
  }
}

// 还款状态
export enum REPAYMENT_STATUS {
  REPAYING = 1,
  FULLY_REPAID = 2,
}

export enum PLAN_STATUS {
  UNPAID = 1,
  PARTIAL_REPAID = 2,
  REPAID = 3,
  // Cache Loan#1：Internally Settled(已匹配买家单未还)→ 展示 "Matched to Buyer Order"
  // BFF TD 6.7 plan_status 已确认：枚举 9 = internally settled
  MATCHED_TO_BUYER_ORDER = 9,
}

export enum OVERDUE_STATUS {
  NORMAL = 0,
  OVERDUE = 1,
}

// repayment状态
export const repaymentStatusMap: any = {
  [REPAYMENT_STATUS.REPAYING]: formatMessage({ id: 'history.repayment_status_1' }),
  [REPAYMENT_STATUS.FULLY_REPAID]: formatMessage({ id: 'history.repayment_status_2' }),
};

// repayment状态(埋点上报)
export const repaymentStatusTrackMap: any = {
  [REPAYMENT_STATUS.REPAYING]: 'repaying',
  [REPAYMENT_STATUS.FULLY_REPAID]: 'fully_repaid',
};

export const overdueStatusMap: any = {
  [OVERDUE_STATUS.OVERDUE]: formatMessage({ id: 'disbursement_detail.overdue' }),
};

export const planStatusMap: any = {
  [PLAN_STATUS.UNPAID]: formatMessage({ id: 'disbursement_detail.unpaid' }),
  [PLAN_STATUS.REPAID]: formatMessage({ id: 'disbursement_detail.repaid' }),
  [PLAN_STATUS.PARTIAL_REPAID]: formatMessage({
    id: 'disbursement_detail.partial_repaid',
  }),
  [PLAN_STATUS.MATCHED_TO_BUYER_ORDER]: formatMessage({
    id: 'repayment_detail.matched_to_buyer_order',
  }),
};

export const overdueStatusTrackMap: any = {
  [OVERDUE_STATUS.OVERDUE]: 'overdue',
};

export const planStatusTrackMap: any = {
  [PLAN_STATUS.UNPAID]: 'unpaid',
  [PLAN_STATUS.REPAID]: 'repaid',
  [PLAN_STATUS.PARTIAL_REPAID]: 'partial_repaid',
  [PLAN_STATUS.MATCHED_TO_BUYER_ORDER]: 'matched_to_buyer_order',
};

// Cache 列表/详情：放款类型文案(BFF order_type)。仅 cache_user=True 时使用；非 cache 维持现状。
//   1=Loan#1 预支单 → "Advance Fulfilled"
//   0=Loan#2/标准单 → "Fulfilled to Buyer"
export const fulfilmentTypeMap: { [key: number]: string } = {
  [FAST_ESCROW_ORDER_TYPE.CACHE]: formatMessage({ id: 'disbursement.advance_fulfilled' }),
  [FAST_ESCROW_ORDER_TYPE.NORMAL]: formatMessage({
    id: 'disbursement.fulfilled_to_buyer',
  }),
};

export default History;
